// @flow
import {autoLogIn} from 'modules/auth/actions/auth';
import {FullLoader} from 'modules/common/components/FullLoader';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {version} from '../../../../package.json';

type TProps = {
    children: React$Node,
};

/**
 * Загружает минимально необходимые данные для работы приложения
 * @returns React-компонент
 */
export const Prefetch = ({children}: TProps) => {
    const [isReady, setIsReady] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        (async () => {
            try {
                await dispatch(autoLogIn());
                setIsReady(true);
            } catch (e) {
                setIsReady(true);
            }
        })();
    }, [dispatch]);

    return (
        <>
            {isReady ? children : <FullLoader />}
            <div className="po_a c_gray-4 f-s_xs" style={{bottom: '2px', right: '5px'}}>
                v{version}
            </div>
        </>
    );
};
